import SearchFilter from './SearchFilter'
import Pagination from './Pagination'
import { getMinimumSessionDetail, getMinDashboardSessionDetail } from './SessionDetail'

export const getSessionSearch = (includeAudiences = false) => `
  ${SearchFilter}
  ${Pagination}
  ${getMinimumSessionDetail(includeAudiences)}
  fragment SessionSearch on SessionSearch {
    filters {
      ...SearchFilter
    }
    paginationData {
      ...Pagination
    }
    results {
      ...MinimumSessionDetail
    }
  }
`

export const SessionSearch = getSessionSearch(false)

export const getDashboardSessionSearch = (includeAudiences = false) => `
  ${SearchFilter}
  ${Pagination}
  ${getMinDashboardSessionDetail(includeAudiences)}
  fragment DashboardSessionSearch on SessionSearch {
    filters {
      ...SearchFilter
    }
    paginationData {
      ...Pagination
    }
    results {
      ...MinDashboardSessionDetail
    }
  }
`

export const DashboardSessionSearch = getDashboardSessionSearch(false)
